import type { AccountType } from '../../types/account'

export const ACCOUNT_TYPES = [
  { id: 'cash' as const, title: 'Efectivo' },
  { id: 'bank' as const, title: 'Banco' },
  { id: 'digital' as const, title: 'Digital' },
]

export function accountTypeLabel(type: AccountType | string): string {
  return ACCOUNT_TYPES.find((item) => item.id === type)?.title || type
}

export function formatMoney(value: number | null | undefined): string {
  const amount = Number(value)
  return new Intl.NumberFormat('es-EC', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(amount) ? amount : 0)
}

export function readList<T>(response: { data: unknown }, message: string): T[] {
  if (!Array.isArray(response.data)) {
    throw new Error(message)
  }
  return response.data
}

export function errorMessage(error: unknown, fallback: string): string {
  const detail = (error as { response?: { data?: { detail?: string } } })?.response?.data?.detail
  return detail || fallback
}
